import * as S from './LoadingPlaceholder.styled'

export const LoadingPlaceholder = ({ ...props }) => {
  return (
    <S.LoadingPlaceholder
      full
      background="gray5"
      height="100%"
      radius="2px"
      {...props}
    />
  )
}

export default LoadingPlaceholder
